// extracted by mini-css-extract-plugin
export default {"container":"WebsiteInput_container__S-D1W","inputDiv":"WebsiteInput_inputDiv__vq2Cu","textInput":"WebsiteInput_textInput__Q3JK9","trashsvg":"WebsiteInput_trashsvg__8BsHd"};